import { Link } from 'react-router-dom';
import { BookOpenIcon, PlayIcon } from 'lucide-react';
import { findDoc } from '@/help/content';
import { CardBadge, CardBody, CardEyebrow, CardShell } from './card-primitives';

/**
 * A help page the assistant pointed at: the title and summary from the
 * bundled docs, Open, and Show me when the page has a tour.
 */
export function HelpCard({ area, slug, label }: { readonly area: string; readonly slug: string; readonly label?: React.ReactNode }): React.ReactElement {
  const doc = findDoc(area, slug);
  const to = `/help/${area}/${slug}`;
  return (
    <CardShell>
      <CardBody>
        <span className="flex items-start gap-3">
          <CardBadge>
            <BookOpenIcon aria-hidden className="size-[18px]" />
          </CardBadge>
          <span className="min-w-0 flex-1">
            <CardEyebrow>Help</CardEyebrow>
            <span className="mt-0.5 block font-bold text-portal-ink">{doc?.title ?? label ?? 'Help page'}</span>
            {doc?.summary ? <span className="mt-0.5 block text-admin-micro text-admin-muted">{doc.summary}</span> : null}
          </span>
        </span>
        <span className="mt-2.5 flex items-center gap-2">
          <Link to={to} className="inline-flex items-center gap-1 rounded-md bg-brand px-2.5 py-1 text-admin-micro font-bold text-white no-underline hover:brightness-110">
            Open
          </Link>
          {doc?.guide ? (
            <Link to={`${to}?guide=1`} className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-admin-micro font-bold text-brand no-underline hover:underline">
              <PlayIcon aria-hidden className="size-3" /> Show me
            </Link>
          ) : null}
        </span>
      </CardBody>
    </CardShell>
  );
}
